// Canonical public paths for the V2 pages vs the developer-only /dev-preview
// base. The same V2 components render in BOTH bases (public + preview), so every
// nav/footer/CTA/redirect resolves its href through v2Href(preview, key) — a
// find-and-replace strip is wrong because the names differ (home->"/",
// contact->"/contact-us"). Keep these two maps in lockstep with App.js routes.

export const CANONICAL_PATHS = {
  home: "/",
  ourDoors: "/our-doors",
  quote: "/quote",
  contact: "/contact-us",
  privacy: "/privacy-policy",
  terms: "/terms-of-service",
};

export const PREVIEW_PATHS = {
  home: "/dev-preview/home",
  ourDoors: "/dev-preview/our-doors",
  quote: "/dev-preview/quote",
  contact: "/dev-preview/contact",
  privacy: "/dev-preview/privacy-policy",
  terms: "/dev-preview/terms-of-service",
};

/**
 * Resolve a V2 route href for the current base.
 * @param {boolean} preview - true inside the /dev-preview developer base.
 * @param {keyof CANONICAL_PATHS} key
 */
export const v2Href = (preview, key) =>
  (preview ? PREVIEW_PATHS : CANONICAL_PATHS)[key];
